import { gql } from 'react-apollo';
import { toastr } from 'react-redux-toastr';
import { change } from 'redux-form';
import fetch from '../../core/fetch';
import {
  CREATE_BLOG_PHOTOS_START,
  CREATE_BLOG_PHOTOS_SUCCESS,
  CREATE_BLOG_PHOTOS_ERROR,
  REMOVE_BLOG_PHOTOS_START,
  REMOVE_BLOG_PHOTOS_SUCCESS,
  REMOVE_BLOG_PHOTOS_ERROR
} from '../../constants';
import { getBlogPhotos } from '../getBlogPhotos';

export function createBlogPhotos(blogId, name, type) {

  return async (dispatch, getState, { client }) => {

    dispatch({
      type: CREATE_BLOG_PHOTOS_START,
    });

    try {
      let mutation = gql`
        mutation UploadBlogPhotos ($blogId:Int!, $name: String, $type: String) {
          CreateBlogPhotos (blogId:$blogId, name: $name, type: $type) {
            status
            photosCount
          }
        } 
      `;
      // Send Request to create a record for a blog
      const { data } = await client.mutate({
        mutation,
        variables: { blogId, name, type },
      });

      if (data && data.CreateBlogPhotos && data.CreateBlogPhotos.status === 'success') {
        dispatch(getBlogPhotos(blogId));
        dispatch({
          type: CREATE_BLOG_PHOTOS_SUCCESS,
          photosCount: data.CreateBlogPhotos.photosCount
        });
        toastr.success('Success!', 'Your blog photo is uploaded successfully!');
      }

    } catch (error) {
      dispatch({
        type: CREATE_BLOG_PHOTOS_ERROR,
      });
      return false;
    }

    return true;
  };
}


export function removeBlogPhotos(blogId, name, reload, isCoverPhoto) {

  return async (dispatch, getState, { client }) => {

    dispatch({
      type: REMOVE_BLOG_PHOTOS_START,
    });

    try {
      let mutation = gql`
        mutation RemoveBlogPhotos($blogId:Int!, $name:String) {
          RemoveBlogPhotos (blogId:$blogId, name: $name) {
            status
            photosCount
            iscoverPhotoDeleted
          }
        }
      `;

      const { data } = await client.mutate({
        mutation,
        variables: { blogId, name },
      });

      if (data && data.RemoveBlogPhotos && data.RemoveBlogPhotos.status === 'success') {
        if (data.RemoveBlogPhotos.isCoverPhotoDeleted || isCoverPhoto) {
          await dispatch(change('BlogDetails', 'coverPhoto', null));
        }
        dispatch({
          type: REMOVE_BLOG_PHOTOS_SUCCESS,
          photosCount: data.RemoveBlogPhotos.photosCount
        });
        dispatch(getBlogPhotos(blogId));

        // Remove file physically
        const resp = await fetch('/deleteBlogPhotos', {
          method: 'post',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ fileName: name }),
          credentials: 'include',
        });
        const { status } = await resp.json();
      }
    } catch (error) {
      dispatch({
        type: REMOVE_BLOG_PHOTOS_ERROR,
        payload: {
          error
        }
      });
      return false;
    }

    return true;
  };
}



// WEBPACK FOOTER //
// src/actions/siteadmin/manageBlogPhotos.js